var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4C11.52 14.4 14.4 11.52 14.4 8C14.4 4.48 11.52 1.6 8 1.6C4.48 1.6 1.6 4.48 1.6 8C1.6 11.52 4.48 14.4 8 14.4ZM8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0ZM8.4 8.64L4.56 10.88L4 9.76L7.2 7.92V4H8.4V8.64Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clockicon.7ff068c5771fc450423716627d9cc47f.svg";
export { ForwardRef as ReactComponent };